import { PublicKey } from '@solana/web3.js';

export const STABLE_COIN_PROGRAM_ID = new PublicKey(
  '5zoAWmSeQ7EoUHtmnXxZrNcuR2ae8c3G2ny1GsAk9Zea',
);
export const ORACLE_PROGRAM_ID = new PublicKey('7wDPbuSVYgwZYJHJqSJfLPezyt89JzvKA8dX5yTk9FgM');

export const CHEF_PROGRAM_ID = new PublicKey('4mm4Qtv8zSZtVjfVMSe4rGJuUoJ8PBvhw8CGLtrF13kb')